import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import CustomPrimeTable from '../../../../../../common/PrimeTable/CustomPrimeTable'
import { OUT_GOING_CALL } from '../../../../../../constants/activityTypes'
import useContactUrl from '../../../../../../hooks/useContactUrl'
import useTablePaginationConfig from '../../../../../../hooks/useTablePaginationConfig'
import { timeWithoutTimeZone } from '../../../../../../utils/utcTime'
import CustomNumberFormat from '../../../../../ClickToCall/InputWithCustomFormat'
import { getContacts } from '../../redux/accountsInsightsActions'
import Loader from './../../../../../Loader/BasicLoader'

export default function ContactTable({ filters, chartFilters }) {
  const { options, onPageChange, onFilterChange, onSortChange, sortMeta } = useTablePaginationConfig(
    { name: -1 },
    {},
    {},
    { ...chartFilters, ...filters }
  )

  const { loading, data } = useSelector((state) => ({
    loading: state.dashboardAccountsInsights.loading,
    data: state.dashboardAccountsInsights.contacts,
  }))

  const dispatch = useDispatch()

  const { getUrl } = useContactUrl()

  useEffect(() => {
    dispatch(getContacts(options))
  }, [options])

  const nameBody = (rowData) => {
    return (
      <>
        <Link rel='noopener noreferrer' onClick={() => window.open(getUrl(rowData), '_blank')}>
          {rowData?.name}
        </Link>
      </>
    )
  }

  const phoneColumnBody = (rowData) => {
    let businessPhone = rowData?.businessPhone
    let id = rowData?.id
    let name = rowData?.name

    return (
      <div onClick={(e) => e.stopPropagation()}>
        <CustomNumberFormat
          className={'form-control-sm form-control'}
          name='office_phone'
          value={businessPhone || ''}
          placeholder='Office Phone'
          type='tel'
          disabled
          format='(999) 999-9999'
          size={10}
          contactId={id}
          contactName={name}
          activityType={OUT_GOING_CALL}
        />
      </div>
    )
  }

  const organizationTypeBody = (rowData) => {
    return <div>{rowData.organizationTypeName}</div>
  }

  const lastMeetingDateBody = (rowData) => {
    return <div>{timeWithoutTimeZone(rowData.divisionLastMeetingDate)}</div>
  }

  const lastContactDateBody = (rowData) => {
    return <div>{timeWithoutTimeZone(rowData.divisionLastContactDate)}</div>
  }
  //    business phone
  const columns = [
    {
      field: 'name',
      header: 'Name',
      body: nameBody,
    },
    { field: 'dotNumber', header: 'DOT Number', style: { textAlign: 'center' } },
    { field: 'mcNumber', header: 'MC Number', style: { textAlign: 'center' } },
    { field: 'organizationTypeId', header: 'Org. Type', body: organizationTypeBody, style: { textAlign: 'center' } },
    { field: 'stateName', header: 'State', style: { textAlign: 'center' } },
    { field: 'numberOfTrucks', header: 'Trucks', style: { width: '5%', textAlign: 'center' } },
    { field: 'email', header: 'Email', style: { width: '15%', textAlign: 'center' } },
    { field: 'ownerName', header: 'Company Owner', style: { textAlign: 'center' } },
    { field: 'nationalityName', header: 'Nationality', style: { textAlign: 'center' } },
    { field: 'companyTypeName', header: 'Company Type', style: { textAlign: 'center' } },
    {
      field: 'businessPhone',
      header: 'Business Phone',
      body: phoneColumnBody,
      style: { width: '12%' },
    },
    { field: 'divisionLastContactDate', header: 'Last Contact Date', body: lastContactDateBody },
    { field: 'divisionLastMeetingDate', header: 'Last Meeting Date', body: lastMeetingDateBody },
    { field: 'assignedName', header: 'Assigned User' },
  ]

  return (
    <>
      {loading && <Loader />}
      <CustomPrimeTable
        data={data.data}
        columns={columns}
        addHidden
        defaultSortMeta={sortMeta()}
        findHidden
        showActions={false}
        onFilter={onFilterChange}
        onSort={onSortChange}
        onPage={onPageChange}
        query={data.query}
      />
    </>
  )
}
